import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import Layout from '../components/Layout';
import OrgRegister from '../pages/OrgRegister';

import DocumentList from "../pages/DocumentList";
import BrandList from '../pages/BrandList';
import UserList from '../pages/UserList';
import VoucherList from '../pages/VoucherList';
import PurchaseList from '../pages/PurchaseList';
import TransactionList from '../pages/TransactionList';
import NegotiateList from '../pages/NegotiateList';
const Routers = () => {
    return (
        <Routes>
            <Route element={<Layout />}>
            <Route
                path="/dashboard"
                element={
                        <Dashboard />
                }
            />
            {/* <Route
                path="/org-register"
                element={
                        <OrgRegister />
                }
            /> */}
            <Route
                path="/brand-list"
                element={
                        <BrandList />
                }
            />
              <Route
                path="/voucher-list"
                element={
                        <VoucherList />
                }
            />
             <Route
                path="/voucher-list"
                element={
                        <VoucherList />
                }
            />
             <Route
                path="/purchase-list"
                element={
                        <PurchaseList />
                }
            />
                 <Route
                path="/transaction-list"
                element={
                        <TransactionList/>
                }
            />
               <Route
                path="/negotiate-list"
                element={
                        <NegotiateList/>
                }
            />
                <Route
                path="/user-list"
                element={
                        <UserList/>
                }
            />
            {/* <Route
                path="/document"
                element={
                        <DocumentList />
                }
            /> */}
            </Route>
        </Routes>
    );
};

export default Routers;
